import { __assign } from "tslib";
import * as React from 'react';
import { CategoryHeader, dtoToCategoryHeaderProps, } from '../category-header';
import { SolutionGridWrapper, } from '../../solution-grid-wrapper/solution-grid-wrapper';
import s from '../../category/category/category.scss';
import { CategoriesCarousel, } from '../../home/partials/CategoriesCarousel';
import { composer } from '../../../component-decorators/composer';
import { Box, Text } from 'wix-style-react';
import { CategoryHeaderMobile } from '../category-header-mobile/category-header-mobile';
import { useConfigContext } from '../../../config-context';
import { FluidContainer } from '../../FluidContainer';
import { getCollectionDefinition } from '@wix/app-market-collection-widget';
export var dtoToCategoryProps = function (categoryRes, webSolutionsRes, categoriesListRes, t) {
    var slug = categoryRes.tagsAndSubCategories[0].tag.slug;
    var backgroundColor = categoryRes.tagsAndSubCategories[0].tag.colors[0];
    var headerProps = dtoToCategoryHeaderProps(categoryRes);
    var appsCount = webSolutionsRes.webSolutions.length;
    var solutionGridWrapperProps = {
        solutions: webSolutionsRes.webSolutions.map(function (solution, appIndex) {
            return __assign({ appIndex: appIndex }, solution.baseInfo);
        }),
        isCompany: true,
        referralSectionName: getCollectionDefinition(categoryRes.tagsAndSubCategories[0].tag).slug,
    };
    var getCategoryIcon = function (category) {
        return category &&
            category.assetsMap &&
            category.assetsMap.collectionImage &&
            category.assetsMap.collectionImage.assets &&
            category.assetsMap.collectionImage.assets[0] &&
            category.assetsMap.collectionImage.assets[0].url;
    };
    var categoriesCarouselProps = {
        displayName: t('category.exploreByCategory'),
        innerTagsDefinitions: categoriesListRes.categoryToSubCategory
            .map(function (category) { return category.category; })
            .filter(function (category) { return !category.isHidden; })
            .filter(function (category) { return category.slug !== slug; })
            .filter(function (category) { return category.apps.length !== 0; })
            .map(function (category) {
            return {
                name: category.name,
                slug: category.slug,
                description: category.description,
                icon: getCategoryIcon(category),
            };
        }),
    };
    return {
        backgroundColor: backgroundColor,
        headerProps: headerProps,
        solutionGridWrapperProps: solutionGridWrapperProps,
        appsCount: appsCount,
        categoriesCarouselProps: categoriesCarouselProps,
    };
};
export var Category = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var backgroundColor = _a.backgroundColor, headerProps = _a.headerProps, solutionGridWrapperProps = _a.solutionGridWrapperProps, appsCount = _a.appsCount, categoriesCarouselProps = _a.categoriesCarouselProps, t = _a.t, marketplaceStore = _a.marketplaceStore;
    // tslint:disable-next-line: react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    var shouldShowBackButton = marketplaceStore.prevRoute &&
        marketplaceStore.route.referral !== 'back_button' &&
        marketplaceStore.route.referral !== 'menu_navigation';
    return (React.createElement("div", { "data-testid": 'category' },
        React.createElement(Box, { className: s.categoryHeaderBackground, backgroundColor: backgroundColor }, isMobile ? (React.createElement(CategoryHeaderMobile, __assign({}, headerProps, { shouldShowBackButton: shouldShowBackButton }))) : (React.createElement(CategoryHeader, __assign({}, headerProps, { shouldShowBackButton: shouldShowBackButton })))),
        React.createElement(FluidContainer, { className: s.categoryContent },
            React.createElement(Box, { className: s.appsCount },
                React.createElement(Text, { className: s.appsCountText, tagName: "h2" },
                    t('collection.apps-counter', { appsCount: appsCount }),
                    ' ')),
            React.createElement(SolutionGridWrapper, __assign({}, solutionGridWrapperProps))),
        React.createElement(CategoriesCarousel, __assign({}, categoriesCarouselProps))));
});
//# sourceMappingURL=category.js.map